import { useId, useState } from 'react';
import Menu from 'storybookConfig/stories/cells/Menu';
import Collapse, { CollapseChevron } from 'storybookConfig/stories/molecules/Collapse';
import { useAnnouncementToDisplay } from './Announcements';
import { SectionHeading, SubLinkContainer } from './Shared.styles';

interface FooterMenuProps {
  isActive: (path: string) => boolean;
}

const FooterMenu = ({ isActive }: FooterMenuProps) => {
  // An announcement takes ~220px of the sidebar: Settings starts closed so the menu still fits.
  const announcementToDisplay = useAnnouncementToDisplay();
  const [expanded, setExpanded] = useState(!announcementToDisplay);
  const settingsId = useId();

  return (
    <Menu>
      <Menu.LinkButton
        aria-expanded={expanded}
        aria-controls={settingsId}
        onClick={() => {
          setExpanded(!expanded);
        }}
      >
        <SectionHeading>Settings</SectionHeading>
        <CollapseChevron open={expanded} />
      </Menu.LinkButton>
      <Collapse id={settingsId} open={expanded}>
        <SubLinkContainer>
          <Menu.Link
            to="#"
            as="a"
            $iconName="list"
            href="https://moderndropship.frontkb.com/en"
            rel="noopener noreferrer"
            target="_blank"
          >
            Help Center
          </Menu.Link>
          <Menu.Link
            to="#"
            as="a"
            $iconName="headset"
            href="https://moderndropship.frontkb.com/en/contact-us"
            rel="noopener noreferrer"
            target="_blank"
          >
            Submit an Issue
          </Menu.Link>
          <Menu.Link to="/settings" $iconName="settings" $isActive={isActive('/settings/*')}>
            Settings
          </Menu.Link>
        </SubLinkContainer>
      </Collapse>
    </Menu>
  );
};

export default FooterMenu;
